<template>
    <Transition name="fade">
        <div
        v-if="showing"
        class="fixed inset-0 flex items-center justify-center bg-semi-75 z-20"
        >
            <div
                class="mx-2 w-full max-w-2xl max-h-full bg-white shadow-lg rounded-lg p-6 overflow-auto"
            >
                <!-- HEADER -->
                <div class="w-full flex justify-between items-center sticky top-0 bg-white py-2">
                    <slot name="header">
                        <h2 class="text-xl font-bold">Título del Modal</h2>
                    </slot>
                    <button aria-label="close" class="text-xl text-gray-500" @click.prevent="handleClose">×</button>
                </div>

                <!-- BODY -->
                <div class="py-4 ">
                    <slot name="body">
                        Contenido del cuerpo (puedes insertar inputs aquí)
                    </slot>
                </div>

                <!-- FOOTER -->
                <div class="w-full flex justify-end mt-4">
                    <slot name="footer">
                        <!-- Si no envías slot, se usa este por defecto -->
                        <BaseButton variant="danger" @click.prevent="handleClose">Cerrar</BaseButton>
                    </slot>
                </div>
            </div>
        </div>
    </Transition>
</template>

<script>
import BaseButton from "@/components/atoms/BaseButton.vue";

export default {
    name: "BaseModal",
    components: { BaseButton },
    emits: ["close"],
    props: {
        showing: {
            type: Boolean,
            required: true,
        },
        handleClose: { 
            required: true
        } 
    }
};
</script>

<style scoped>
    .bg-semi-75 {
        background-color: rgba(0, 0, 0, 0.75);
    }
</style>
